import React from 'react'

const initialState: { pageWidth: string; setPageWidth: ((val: string) => void) | null } = {
    pageWidth: '100vw',
    setPageWidth: null,
}

const LayoutContext = React.createContext(initialState)

function LayoutProvider({ children }: { children: React.ReactNode }) {
    const [pageWidth, setPageWidth] = React.useState(initialState.pageWidth)

    return <LayoutContext.Provider value={{ pageWidth, setPageWidth }}>{children}</LayoutContext.Provider>
}

export { LayoutProvider, LayoutContext }
